import React from "react";
import { useDispatch } from "react-redux";

import {
  makeStyles,
  TableRow,
  TableCell,
} from "@material-ui/core";

import IconEstado from "../../../autorizaciones/UI/IconEstado";
import AddButtonComprobante from "../../UI/AddButtonComprobante";
import { AUTORIZACIONES_PRESUPUESTOS_ESTADOS } from "../../../../utils/constants";
import { MESA_ENTRADA_PERMISOS } from '../../../../utils/permisos';
import { postComprobanteMesaEntrada } from "../../../../actions/mesaEntrada/mesaEntradaActions";
import { StepperFormExpediente } from "../StepperFormExpediente";

const useStyles = makeStyles({
  iconEstado: {
    "&:hover": {
      backgroundColor: "#80808026",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const PresupuestoItem = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { presupuesto } = props;

  const handleSave = (formValues, handleClose) => {
    dispatch(postComprobanteMesaEntrada(formValues, handleClose));
  }

  return (
    <>
      <TableRow className={classes.iconEstado}>
        <TableCell align="center">
          <IconEstado
            useColorTable={true}
            texto={presupuesto?.estadoPresupuesto?.letra}
            backgroundColor={presupuesto?.estadoPresupuesto?.color}
            descripcion={presupuesto?.estadoPresupuesto?.descripcion}
          />
        </TableCell>
        <TableCell align="center">{presupuesto?.idPresupuesto}</TableCell>
        <TableCell align="center">{presupuesto?.afiliado.id_afiliado}</TableCell>
        <TableCell align="center">{presupuesto?.afiliado.apellido_y_nombre}</TableCell>
        <TableCell align="center">
          {new Date(presupuesto?.fecha).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="center">{presupuesto?.tipoPresupuesto?.descripcionTipo}</TableCell>
        <TableCell align="center">{presupuesto?.conInternacion ? 'SI' : 'NO'}</TableCell>
        <TableCell>{presupuesto?.diagnostico?.problema}</TableCell>
        <TableCell align="center">
          {presupuesto?.estadoPresupuesto?.idEstado ===
            AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO && (
            <AddButtonComprobante 
              title="Agregar Asociación Presupuesto"
              handleSave={handleSave}
              permiso={MESA_ENTRADA_PERMISOS.ALTA}
              form={StepperFormExpediente}
              presupuesto={presupuesto}
            />
          )}
        </TableCell>
      </TableRow>
    </>
  );
};
